<template>
  <div id="Confirm">
    <span>
     {{texto}}
    </span>
    <div class="modal-footer">
      <slot name="footer">
        <button class="btn btn-success" @click="confirmModal($event)">Ok</button>
        <button class="btn btn-cancel" type="cancel" @click="closeModal($event)">Cancelar</button>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Confirm',
  props: ["texto", "elementId"],
  methods: {
    closeModal(){
      this.$emit('confirm-cancel');
    },
    confirmModal(){
      this.$emit('confirm-ok');
    }
  }
 
}
</script>
